const Footer = () => {
    return(
        
        <>
        <div className="footer">
        <div>Contact Us</div>
        <div>Help Center</div>
        <div>Careers</div>
        <div>Gift Cards</div>
        <div>Cancellation & Returns</div>
        </div>
        </>
    )
};

export default Footer;